import { dashboardService } from '../dashboard/dashboard.service';
var dashboardresolveService = (function () {
    function dashboardresolveService(dashboard) {
        this.dashboard = dashboard;
    }
    dashboardresolveService.prototype.resolve = function (route, state) {
        return this.dashboard.getDashboards();
    };
    return dashboardresolveService;
}());
export { dashboardresolveService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/dashboardresolve/dashboardresolve.service.ts.pre-build-optimizer.js